"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.INSIGHTS_TRIGGER_WORKFLOW_CONFIG = {
  name: "insights trigger workflow",
  group: "trigger-workflows",
  templateId: "9a31959f"
};
exports.UTILISATION_TRIGGER_WORKFLOW_CONFIG = {
  name: "utilisation trigger workflow",
  group: "trigger-workflows",
  templateId: "848c8a6c"
};
exports.INVENTORY_TRIGGER_WORKFLOW_CONFIG = {
  name: "inventory trigger workflow",
  group: "trigger-workflows",
  templateId: "403d7d71"
};
exports.getTriggerWorkflowConfigByTabName = tabName => {
  if (tabName === constants_1.TAB_NAME.INSIGHTS)
    return exports.INSIGHTS_TRIGGER_WORKFLOW_CONFIG;
  if (tabName === constants_1.TAB_NAME.UTILISATION)
    return exports.UTILISATION_TRIGGER_WORKFLOW_CONFIG;
  if (tabName === constants_1.TAB_NAME.UTILISATION_SUMMARY)
    return exports.UTILISATION_TRIGGER_WORKFLOW_CONFIG;
  if (tabName === constants_1.TAB_NAME.INVENTORY)
    return exports.INVENTORY_TRIGGER_WORKFLOW_CONFIG;
  if (tabName === constants_1.TAB_NAME.INVENTORY_GLOBAL)
    return exports.INVENTORY_TRIGGER_WORKFLOW_CONFIG;
  return null;
};
//# sourceMappingURL=genricWorkflowsConfig.js.map
